import React, { useState } from 'react';
import TrackingStats from './TrackingStats';
import TrackingEventCard from './TrackingEventCard';

const TrackingView = ({ stats, events, categories, selectedPeriod, onPeriodChange }) => {
  const [subView, setSubView] = useState('stats');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredEvents = selectedCategory === 'all'
    ? events
    : events.filter(e => e.category === selectedCategory);

  return (
    <div>
      <div className="sub-tabs">
        <button className={`sub-tab ${subView === 'stats' ? 'active' : ''}`} onClick={() => setSubView('stats')}>
          Statistiche
        </button>
        <button className={`sub-tab ${subView === 'events' ? 'active' : ''}`} onClick={() => setSubView('events')}>
          Eventi
        </button>
      </div>

      <div className="filters-bar">
        <div className="filters-row">
          <div className="period-pills">
            {['today', 'week', 'month'].map(p => (
              <button key={p} className={`period-pill ${selectedPeriod === p ? 'active' : ''}`} onClick={() => onPeriodChange(p)}>
                {p === 'today' ? 'Oggi' : p === 'week' ? 'Settimana' : 'Mese'}
              </button>
            ))}
          </div>
          {subView === 'events' && categories.length > 0 && (
            <select className="filter-select" value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}>
              <option value="all">Tutte le categorie</option>
              {categories.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          )}
        </div>
      </div>

      <main>
        {subView === 'stats' && <TrackingStats stats={stats} selectedPeriod={selectedPeriod} />}
        {subView === 'events' && (
          <div className="operational-list">
            {filteredEvents.length === 0 ? (
              <div className="empty-state">
                <div className="empty-state-icon">📊</div>
                <div className="empty-state-text">Nessun evento nel periodo selezionato</div>
              </div>
            ) : (
              filteredEvents.map(e => <TrackingEventCard key={e.id} event={e} />)
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default TrackingView;
